import { Component } from '@angular/core';
import { AuthService, StateService } from 'src/app/services';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AddThemeRequest, AddThemeResponse, SituViewWebApiClient, Theme } from 'situview-webapi-client';
import { SituBaseComponent } from 'src/app/shared/situ-base-component';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'themes-add',
  templateUrl: './themes-add.component.html',
  styleUrls: ['./themes-add.component.scss']
})

export class ThemesAddComponent extends SituBaseComponent {
  themeName = new FormControl('', [Validators.required]);
  
  /* Loading */
  private _loading = false;
  
  public get loading(): boolean {
    return this._loading;
  }

  public set loading(val: boolean) {
    this._loading = val;
  }

  constructor(
    authService: AuthService,
    stateService: StateService,
    private situViewClient: SituViewWebApiClient,
    private router: Router,
    private snackBar: MatSnackBar) {
    super(authService, stateService);
  }

  addTheme() {
    if (this.themeName?.value && this.themeName.valid) {
      let request = new AddThemeRequest();
      let theme = new Theme();
      theme.companyId = this.selectedCompany?.id;
      theme.name = this.themeName.value;
      request.theme = theme;
      return this.situViewClient.addTheme(request)
        .then((response: AddThemeResponse) => {
          if (response.success) {
            this.router.navigate([`/homes/themes`, theme.name]);
          } else {
            this.showMessage(response?.errorMessages![0]);
          }
        })
        .catch((err) => {
          this.showMessage("Sorry! There was an issue creating the new theme.");
        });
    }
  }

  private showMessage(message: string) {
    this.snackBar.open(message, 'Dismiss', {
      duration: 3000
    });
  }
}